<div class="device-detail-container">
  <div class="content">
    <div class="device-info" *ngIf="device$ | async as device">
      <kion-device-info
        [device]="device"
        [cartId]="(deviceCart$ | async)?.id"
        [badgeNumber]="(deviceCart$ | async)?.entries?.length"
      ></kion-device-info>
    </div>
    <div class="features" *ngIf="device$ | async as device">
      <kion-feature-list
        *ngIf="features$ | async as features"
        [device]="device"
        [features]="features"
        [cart]="deviceCart$ | async"
        [roles]="roles$ | async"
        (addToCart)="addToCart($event)"
      ></kion-feature-list>
    </div>
  </div>
</div>
